import {Button} from "@material-ui/core";
import React from "react";
import {useHistory, useParams} from "react-router-dom";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import {EventIntf} from "../ServerTypes";

export default function EventAdminNav(props: {event:EventIntf}) {
    const history = useHistory();
    const {eventId} = useParams()

    return <AppBar position="relative" color="default">
        <Toolbar>
            <Typography variant="h3" color="inherit" noWrap>
                {props.event.name}
            </Typography>
            &nbsp;&nbsp;
            <div>
                <Button onClick={() => {history.push(`/admin/event/${eventId}`)}} variant="contained" color="primary">Edit Event</Button>
                <Button onClick={() => {history.push(`/admin/eventvenue/${eventId}`)}} variant="contained" color="primary">Edit Venue Data</Button>
                <Button onClick={() => {history.push(`/admin/event/${eventId}/manage-attendees`)}} variant="contained" color="primary">Manage Attendees</Button>
                <Button onClick={() => {history.push(`/admin/event/${eventId}/manage-eventbrite`)}} variant="contained" color="primary">Manage EventBrite</Button>
            </div>
        </Toolbar>
    </AppBar>
}
